"use client";

import { useLayoutEffect, useRef } from "react";
import { AlertTriangle } from "lucide-react";

const WITHDRAWAL_FORM_URL = "https://parlaye.notion.site/360c5b6806108017aaa8d7c6c112fe7b";

export default function ShutdownBanner() {
  const bannerRef = useRef(null);

  useLayoutEffect(() => {
    const setHeightVar = () => {
      if (bannerRef.current) {
        document.documentElement.style.setProperty(
          "--parlaye-banner-height",
          `${bannerRef.current.offsetHeight}px`
        );
      }
    };
    setHeightVar();
    window.addEventListener("resize", setHeightVar);
    return () => window.removeEventListener("resize", setHeightVar);
  }, []);

  return (
    <div
      ref={bannerRef}
      className="fixed top-0 left-0 w-full z-[100] px-4 sm:px-6 py-3"
      style={{
        background: "#F59E0B",
        color: "#111111",
        borderBottom: "1px solid rgba(0,0,0,0.15)",
      }}
      role="alert"
    >
      <div className="max-w-6xl mx-auto flex flex-col items-center gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2.5 text-center sm:text-left">
          <AlertTriangle size={18} className="shrink-0" />
          <div>
            <div className="text-sm sm:text-[15px] font-bold leading-snug">
              Parlaye has suspended operations. If you have funds in your account, submit a withdrawal request.
            </div>
            <div className="text-[13px] mt-0.5" style={{ opacity: 0.85 }}>
              Withdrawal requests submitted after August 1st will be sent in 1 batch in early September.
            </div>
          </div>
        </div>
        <a
          href={WITHDRAWAL_FORM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="shrink-0 w-full sm:w-auto text-center text-sm font-medium px-[18px] py-[6px] rounded-full transition-all duration-200"
          style={{
            border: "1.5px solid #111111",
            color: "#111111",
            background: "transparent",
          }}
          onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(17,17,17,0.08)"; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
        >
          Submit Withdrawal Request →
        </a>
      </div>
    </div>
  );
}
